<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form='form'>
        <a-row>
          <a-col :span='12'>
            <a-form-item label='配置id' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'setId', validatorRules.setId]" placeholder='请输入配置id'
                       :disabled='ifEdit'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='配置名称' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'setName', validatorRules.setName]" placeholder='请输入配置名称'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头业务表' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'dataTable', validatorRules.dataTable]" placeholder='请输入源头业务表'
                       :disabled='ifEdit'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标业务表' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'targetTable', validatorRules.targetTable]" placeholder='请输入目标业务表'
                       :disabled='ifEdit'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头业务表主键' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'dataKey', validatorRules.dataKey]" placeholder='请输入源头业务表主键'
                       :disabled='ifEdit'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标业务表主键' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'targetKey', validatorRules.targetKey]" placeholder='请输入目标业务表主键'
                       :disabled='ifEdit'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='源头业务表字段' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'dataField', validatorRules.dataField]" placeholder='请输入源头业务表字段'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='目标业务表字段' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'targetField', validatorRules.targetField]" placeholder='请输入目标业务表字段'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='过滤条件' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'dataFilter', validatorRules.dataFilter]" placeholder='请输入过滤条件'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='12'>
            <a-form-item label='备注' :labelCol='labelCol' :wrapperCol='wrapperCol'>
              <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder='请输入备注'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="删除数据是否同步" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['delDataFlag', validatorRules.delDataFlag]"
                :trigger-change="true"
                dictCode="yn"
                placeholder="请选择删除数据是否同步"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'

  export default {
    name: "BusDataSyncDocDetailSetModal",
    components: {
    },
    props:{
      mainSetId:{
        type:String,
        required:false,
        default:''
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
        setId:{rules: [{ required: true, message: '请输入配置id!' }]},
        setName:{rules: [{ required: true, message: '请输入配置名称!' }]},
        dataTable:{rules: [{ required: true, message: '请输入源头业务表!' }]},
        targetTable:{rules: [{ required: true, message: '请输入目标业务表!' }]},
        dataKey:{rules: [{ required: true, message: '请输入源头业务表主键!' }]},
        targetKey:{rules: [{ required: true, message: '请输入目标业务表主键!' }]},
        dataField:{rules: [{ required: true, message: '请输入源头业务表字段!' }]},
        targetField:{rules: [{ required: true, message: '请输入目标业务表字段!' }]},
        dataFilter:{},
        remarks:{},
        delDataFlag:{rules: [{ required: true, message: '请选择删除数据是否同步!' }]},
        },
        url: {
          add: "/datadocsync.base/busDataSyncDocMainSet/addBusDataSyncDocDetailSet",
          edit: "/datadocsync.base/busDataSyncDocMainSet/editBusDataSyncDocDetailSet",
        }

      }
    },
    created () {
    },
    computed: {
      ifEdit() {
        return !!this.model.id
      },
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'setId','mainSetId','setName','dataTable','targetTable','dataKey','targetKey','dataField','targetField','dataFilter','remarks','delDataFlag','createBy','createTime','updateBy','updateTime'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            formData['mainSetId'] = this.mainSetId
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'setId','mainSetId','setName','dataTable','targetTable','dataKey','targetKey','dataField','targetField','dataFilter','remarks','delDataFlag','createBy','createTime','updateBy','updateTime'))
      },


    }
  }
</script>
